// TODO: Set, Map
export function clone<T>(value: T): T {
  if (typeof value !== 'object' || value == null) {
    return value;
  }

  if (Array.isArray(value)) {
    return [...value] as T;
  }

  return { ...value };
}
